import { render, staticRenderFns } from "./materialMark.vue?vue&type=template&id=0f57d8fc&scoped=true&"
import script from "./materialMark.vue?vue&type=script&lang=js&"
export * from "./materialMark.vue?vue&type=script&lang=js&"
import style0 from "./materialMark.vue?vue&type=style&index=0&id=0f57d8fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57d8fc",
  null
  
)

export default component.exports